import { useCallback, useReducer, useRef, useEffect } from "react";
var reducer = function (_, _a) {
    var reason = _a.reason, value = _a.value;
    if (reason === "reset")
        return "";
    return value;
};
export default (function () {
    var _a = useReducer(reducer, ""), searchString = _a[0], dispatch = _a[1];
    var timerRef = useRef(undefined);
    useEffect(function () { return function () { return clearTimeout(timerRef.current); }; }, []);
    var onInputChange = useCallback(function (event, value, reason) { return !(event === null && reason === "reset") && dispatch({ value: value, reason: reason }); }, []);
    return { onInputChange: onInputChange, searchString: searchString };
});
//# sourceMappingURL=useSelectSearch.js.map